import { WEBSITE, validateFns } from '@/components/validation/tool/validator';
import { i18n } from '@/main';

const { regExp, tips } = WEBSITE;

function validateWebsite(rule, value, callback) {
  if (!value || regExp.test(value)) {
    callback();
  } else {
    callback(new Error(i18n.t(tips)));
  }
}

export const rules = () => ({
  // website: [
  //   { validator: validateWebsite, trigger: 'input' },
  // ],
});
